import { getImageFromIndexedDB } from '@/utils/imageStorage';
import { imageSpaceAPI } from '@/utils/api';
import { isImageSpaceTempLocalId } from '@/utils/imageSpaceImportId';

/** Studio 本地上传临时 id（未入库图片空间），勿对 /admin/image-space 发起查询 */
function isEphemeralStudioUploadId(imageId) {
  return /^crop-\d+-[a-z0-9]+$/i.test(String(imageId || '').trim());
}

async function blobUrlToDataUrl(blobUrl) {
  const response = await fetch(blobUrl);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/** 列表/详情/后台 worker 共用的原图解析（不依赖页面 state，离开列表页仍可裁剪） */
export async function resolveImageCropOriginalUrl(imageId, { localUrlMap, imageSpaceImages } = {}) {
  const key = String(imageId);
  let url = '';

  const fromSpace = (imageSpaceImages || []).find((img) => String(img.id) === key);
  if (fromSpace) {
    url = fromSpace.url || fromSpace.dataUrl || '';
  }
  if (!url && localUrlMap?.[key]) {
    url = localUrlMap[key];
  }
  if (!url) {
    try {
      url = (await getImageFromIndexedDB(key)) || '';
    } catch {
      /* ignore */
    }
  }
  if (!url && !isEphemeralStudioUploadId(key) && !isImageSpaceTempLocalId(key)) {
    try {
      const res = await imageSpaceAPI.getById(key);
      const image = (res && typeof res === 'object' ? res.image || res.data : null) || res || {};
      url = image?.url || image?.dataUrl || '';
    } catch {
      /* ignore */
    }
  }
  if (!url) return '';

  if (url.startsWith('blob:')) {
    try {
      url = await blobUrlToDataUrl(url);
    } catch {
      return '';
    }
  }
  if (
    url.startsWith('/uploads/')
    || url.startsWith('uploads/')
  ) {
    return url.startsWith('/') ? url : `/${url.replace(/^\/+/, '')}`;
  }
  return url;
}
